import { useState, useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { PORTAL_ROOT_ID } from '@utils/portal'; // Make sure this path is right!

interface PortalManagerProps {
  isOpen: boolean;
  children: ReactNode;
}

// Manages the magic portal! ✨🚪
export const PortalManager: React.FC<PortalManagerProps> = ({ isOpen, children }) => {
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    // Can't do this on the server, ze~!
    if (typeof window === 'undefined') return;

    let element = document.getElementById(PORTAL_ROOT_ID);
    if (!element) {
      console.log(`Portal root #${PORTAL_ROOT_ID} not found, creating it!`);
      element = document.createElement('div');
      element.id = PORTAL_ROOT_ID;
      // Add some styles maybe? Or just let it be plain.
      element.style.position = 'relative';
      element.style.zIndex = '9998'; // Below dropdown but above most things
      document.body.appendChild(element);
    } else {
      console.log(`Found portal root #${PORTAL_ROOT_ID}!`);
    }

    setPortalElement(element);

    // Marisa doesn't usually clean up dynamically created *global* elements,
    // but you could add cleanup here if needed, ze~!
    // return () => { /* Optional cleanup */ };
  }, []); // Run only once on mount

  // Only render the portal if it's open AND the element exists!
  if (!isOpen || !portalElement) {
    // Log if portal isn't ready when needed
    if (isOpen && !portalElement) {
      console.warn('Trying to open portal, but element not ready yet!');
    }
    return null;
  }

  return createPortal(children, portalElement);
};
